/* Copyright 2020 The MathWorks, Inc. */

/**
 * This module defines the mapping between the event name as expected by the UIBuilder public API and the actual event
 * emitted by the widget.
 */

define([
        "dojo/_base/lang",
        "MW/toolstrip/hashes/PeerNodeWidgetEventsHash",
        "MW/statusbar/hashes/PeerNodeWidgetEventsHash"
], function (lang, ToolstripPeerNodeWidgetEventsHash, StatusBarPeerNodeWidgetEventsHash) {
    
    var hash = {};

    lang.mixin(hash, ToolstripPeerNodeWidgetEventsHash);
    lang.mixin(hash, StatusBarPeerNodeWidgetEventsHash);

    return hash;
});